<template>
  <div class="admissionCue">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-admissionCue">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <span class="c-normal">{{ $t("Admissioncue.aa") }}</span>
            </div>
          </div>
          <div class="admissionCue-container">
            <div class="content content-special">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == current }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="c-n--head_rt">
                  <el-button type="warning" @click="importAdmission()">{{
                    $t("Admissioncue.ab")
                  }}</el-button>
                  <el-button type="success" @click="ClickAddAdmission()">{{
                    $t("Admissioncue.ac")
                  }}</el-button>
                  <el-button type="primary" @click="daochu">{{
                    $t("Common.btn_export")
                  }}</el-button>
                  <!-- *************暂时隐藏***************** -->
                  <!-- <el-button type="warning">招生二维码</el-button>
									<el-button type="primary">批量导入</el-button>
                  <el-button type="danger">导出报表</el-button>-->
                </div>
              </div>
              <div
                v-if="isShowListTips && notreadnum > 0"
                class="listUpdate-tips mb12"
              >
                <div class="tc">
                  <i class="el-icon-warning"></i>
                  <span
                    >{{ $t("Admissioncue.tips1") }}{{ notreadnum
                    }}{{ $t("Admissioncue.tips2") }}</span
                  >
                </div>
                <i
                  class="el-icon-close tip-close"
                  @click="isShowListTips = !isShowListTips"
                ></i>
              </div>
              <div v-if="!buttonHide" class="flex-wrap pl20 pr20">
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.source"
                      @change="handleSelect()"
                      :placeholder="$t('Admissioncue.ae')"
                    >
                      <el-option
                        v-for="item in SchoolsourceOption"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.activity"
                      class="select-mini"
                      @change="handleSelect()"
                      :placeholder="$t('Admissioncue.ah')"
                    >
                      <el-option
                        v-for="item in ActivityOption"
                        :key="item.activity_id"
                        :label="item.activity_name"
                        :value="item.activity_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.channel"
                      class="select-mini"
                      @change="handleSelect()"
                      :placeholder="$t('Admissioncue.aj')"
                      style="width: 170px"
                    >
                      <el-option
                        v-for="item in ChannelOption"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.lapsed"
                      class="select-mini"
                      @change="handleSelect()"
                      :placeholder="$t('Admissioncue.al')"
                    >
                      <el-option
                        :label="$t('Admissioncue.an')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('Admissioncue.aa')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.client_isnewtip"
                      class="select-mini"
                      style="width: 155px"
                      @change="handleSelect()"
                      :placeholder="$t('Admissioncue.cae')"
                    >
                      <el-option
                        :label="$t('Admissioncue.caf')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('Admissioncue.cag')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666"
                    >名单{{ $t("Common.create_time") }}:</span
                  >
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <!-- <el-input
                      clearable
                      :placeholder="$t('Admissioncue.ao')"
                      class="input-cont"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input> -->
                    <el-input
                      style="width: 250px"
                      clearable
                      placeholder="可检索中英文名、手机号、标签名称"
                      class="input-cont"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                </div>
                <!-- <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      v-if="!buttonHide"
                      :placeholder="$t('Admissioncue.aq')"
                      class="input-cont family-phone"
                      v-model="selectForm.family_mobile"
                      @change="handleSelectKeyword()"
                    ></el-input>
                    <el-button
                      v-if="!buttonHide"
                      type="primary"
                      class="btn-inquire btn-inquire2"
                      @click="handleSelectKeyword()"
                      >{{ $t("Admissioncue.ap") }}</el-button
                    >
                  </div>
                </div> -->
              </div>
              <div v-else-if="buttonHide" class="flex-wrap pl20 pr20">
                <div class="flex-al mb10 mr10">
                  <el-button
                    type="primary"
                    v-if="buttonHide && postbe_crmlevel == '1'"
                    @click="handleClickassign()"
                    >{{ $t("Admissioncue.ar") }}</el-button
                  >
                </div>
                <div class="flex-al mb10 mr10">
                  <el-button
                    v-if="buttonHide"
                    type="primary"
                    @click="handleClickintention()"
                    >{{ $t("Admissioncue.as") }}</el-button
                  >
                </div>
                <div class="flex-al mb10 mr10">
                  <el-button
                    v-if="buttonHide && postbe_crmlevel == '1' && !isFromGmc"
                    type="primary"
                    @click="handleClickloss()"
                    >{{ $t("Admissioncue.at") }}</el-button
                  >
                </div>
              </div>

              <!-- 只有主管权限可以看见 -->
              <!-- <div v-if="postbe_crmlevel=='1'" class="all-state text-1 mb20 clearFloat">
								<div v-if="!buttonHide" class="select-box pull-left mr10">
									<label class="source">名单状态：</label>
									<el-select filterable v-model="selectForm.client_status"  class="select-mini" @change="handleSelect()" placeholder="请选择名单状态">
										<el-option label="不限" value=""></el-option>
                    <el-option label="待分配" value="0"></el-option>
                    <el-option label="未跟踪" value="1"></el-option>
                    <el-option label="已邀约" value="2"></el-option>
                    <el-option label="已试听" value="3"></el-option>
                    <el-option label="已跟踪" value="4"></el-option>
									</el-select>
								</div>
								<div v-if="!buttonHide" class="select-box pull-left mr10">
									<label class="source">跟踪状态：</label>
									<el-select filterable v-model="selectForm.client_track_status" class="select-mini" @change="handleSelect()"  placeholder="请选择跟踪状态">
										<el-option label="不限" value=""></el-option>
                    <el-option label="待分配" value="0"></el-option>
                    <el-option label="待跟踪" value="1"></el-option>
                    <el-option label="跟踪中" value="2"></el-option>
                    <el-option label="已转正" value="3"></el-option>
									</el-select>
								</div>
              </div>-->

              <div
                class="tableList"
                ref="auto_height_table"
                style="position: relative"
              >
                <TableList
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  :operates="operates"
                  @dropdownClick="dropdownClick"
                  @handleCommand="handleCommand"
                  @handleSelectionChange="handleSelectionChange"
                  @handleColumnChange="handleColumnChange"
                  @toggleEditableColumn="toggleEditableColumn"
                ></TableList>
                <div class="personalInfo-tips">
                  <i class="crmIcon-ysbh"></i>
                  <span>{{ $t("Common.personalInfo_tips") }}</span>
                </div>
              </div>

              <el-pagination
                style="margin-top: 20px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>

              <!-- 我要跟进弹窗 中间-->
              <el-dialog
                :title="$t('Admissioncue.au')"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose"
              >
                <div class="capital-box">
                  <div class="delTips tc">{{ allotTips }}</div>
                </div>
                <span v-if="isdistrib" slot="footer" class="dialog-footer">
                  <el-button
                    type="primary"
                    v-if="allot_num != '0'"
                    @click="handclickNow(layoutInformation)"
                    >{{ $t("Admissioncue.av") }}</el-button
                  >
                  <el-button @click="dialogVisible = false">{{
                    $t("Admissioncue.aw")
                  }}</el-button>
                </span>
                <span v-if="!isdistrib" slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogVisible = false">{{
                    $t("Admissioncue.ax")
                  }}</el-button>
                </span>
              </el-dialog>
              <!-- 跟班试听 中间-->
              <auditClass
                :leaningVisible="leaningVisible"
                :auditionGenre="auditionGenre"
                :Auditiontime="Auditiontime"
                @handClickcompare="handClickcompare"
                @handClickcancel="handClickcancel"
                @handleClose="handleCloseLean"
              ></auditClass>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 侧边栏编辑-->
    <SliderBox
      :showSliderBox="showSliderBox"
      @hideSliderBox="hideSliderBox"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBox"
        :Userlist="Userlistedit"
        @hideUserSliderBox="hideSliderBox"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :isEdit="isEdit"
        :FamilyRelation="FamilyRelation"
        :UserInformation="UserInformation"
        :repeatList="repeatList"
        @onSubmit="oneditSubmit"
        @checkIntentionClientData="checkIntentionClientData"
        @deleteFamily="deleteFamily"
        @deleteCourse="deleteCourse"
        @wantToTrack="wantToTrack"
      ></userCreate>
    </SliderBox>

    <!-- 新增招生有效名单 -->
    <SliderBox
      :showSliderBox="showSliderCreateBox"
      @hideSliderBox="hideSliderCreateBox"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderCreateBox"
        :Userlist="Userlistcreate"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :repeatList="repeatList"
        :FamilyRelation="FamilyRelation"
        @onSubmit="onSubmit"
        @wantToTrack="wantToTrack"
        @hideUserSliderBox="hideSliderBox"
        @checkIntentionClientData="checkIntentionClientData"
      ></userCreate>
    </SliderBox>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :isdisabled="isDisabled"
        :newclientTags="newclientTags"
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :activeName="activeName"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @handleSliderClick="handleSliderClick"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Admissioncue.ay')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="120px"
          ref="BindstudentFrom"
          :model="BindstudentFrom"
        >
          <el-form-item
            :label="$t('Admissioncue.az')"
            prop="name"
            :rules="[{ required: true, message: '请选择学员' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Admissioncue.ba')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Admissioncue.bb')"
            prop="relation"
            :rules="[{ required: true, message: '请选择绑定关系' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Admissioncue.bc')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>

    <!-- 分配主副负责人 -->
    <el-dialog
      :title="$t('Admissioncue.bd')"
      :visible.sync="layoutVisible"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form label-width="95px" style="padding: 0px">
          <el-form-item
            :label="$t('Admissioncue.be')"
            :rules="[
              {
                required: company_isassist != 1,
              },
            ]"
          >
            <el-select
              filterable
              clearable
              class="layout-select"
              v-model="layoutFrom.marketer"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bf')"
              @change="(layoutFrom.fu_marketer = ''), getfiterChief()"
            >
              <el-option
                v-for="item in chiefPerson"
                :key="item.marketer_id"
                :label="item.marketer_name"
                :value="item.marketer_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Admissioncue.bg')"
            v-if="company_isassist == 1"
          >
            <el-select
              filterable
              clearable
              collapse-tags
              :disabled="!layoutFrom.marketer"
              class="layout-select"
              v-model="layoutFrom.fu_marketer"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bh')"
              multiple
            >
              <el-option
                v-for="item in fu_chiefPerson"
                :key="item.marketer_id"
                :label="item.marketer_name"
                :value="item.marketer_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onlayoutSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 转校 -->
    <el-dialog
      :title="$t('Admissioncue.cc')"
      :visible.sync="crossSchoolVisible"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form label-width="85px" style="padding: 0px">
          <el-form-item :label="$t('Admissioncue.bi')">
            <el-select
              filterable
              class="layout-select"
              v-model="crossSchoolFrom.school"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bj')"
            >
              <el-option
                v-for="item in schoolGoalList"
                :key="item.school_id"
                :label="`${item.school_cnname}(${item.school_branch})`"
                :value="item.school_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Admissioncue.bk')">
            <el-select
              filterable
              class="layout-select"
              @change="changReason"
              v-model="crossSchoolFrom.reson_code"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bl')"
            >
              <el-option
                v-for="item in reasonList"
                :key="item.transfer_code"
                :label="item.transfer_name"
                :value="item.transfer_code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Admissioncue.bm')">
            <el-input
              clearable
              type="textarea"
              class="layout-select"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bn')"
              v-model="crossSchoolFrom.reason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCrossSchoolSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Admissioncue.dy')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Admissioncue.bo'), $t('Admissioncue.bp')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Admissioncue.ax")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 删除重复名单提示 -->
    <el-dialog
      :title="$t('Admissioncue.au')"
      :visible.sync="delRepeat"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Admissioncue.aq") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delRepeatAction()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <el-button @click="delRepeat = false">{{
          $t("Customersmanage.bk")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import SliderBox from "@/components/SliderBox";
import userCreate from "@/components/User/create.vue";
import userSeeing from "@/components/User/seeing.vue";
import TableList from "@/components/Table/table.vue";
import tipsTable from "@/components/Table/tipsTable.vue";
import auditClass from "@/components/Class/Class.vue";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";
export default {
  name: "admissionCue-admissionCue",
  data() {
    return {
      isDisabled: false,
      newclientTags: [],
      isFromGmc: false, // 是否来源于集团
      openMenu: ["2"],
      showSliderBox: false,
      showSliderBoxSee: false,
      showSliderCreateBox: false,
      settingVisible: false,
      crossSchoolVisible: false, //转校
      delRepeat: false, //删除重复名单
      fullscreenLoading: true, //全屏loading
      seeSliderTitle: this.$t("Admissioncue.aa"),
      currentPage: 1,
      iscanEdit: true,
      isChageTab: false, //是否点击了切换
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      ClassMessage: {}, //选择的试听班级
      data: [],
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      customerId: "", // 客户id
      dialogVisible: false,
      layoutVisible: false, //分配
      // 客户状态0待跟踪1持续跟踪2已柜询3已试听4已转正-1无意向
      clientOption: [
        {
          value: "",
          label: this.$t("Admissioncue.af"),
        },
        {
          value: "0",
          label: this.$t("Admissioncue.br"),
        },
        {
          value: "1",
          label: this.$t("Admissioncue.bs"),
        },
        {
          value: "2",
          label: this.$t("Admissioncue.bt"),
        },
        {
          value: "3",
          label: this.$t("Admissioncue.bu"),
        },
        {
          value: "4",
          label: this.$t("Admissioncue.bv"),
        },
        {
          value: "-1",
          label: this.$t("Admissioncue.bw"),
        },
      ],
      // 转校
      crossSchoolFrom: {
        school: "",
        reson_code: "",
        reason: "",
      },
      schoolGoalList: [], //目标学校
      reasonList: [], //异动原因
      ClientOneId: "", //暂存转校Id
      // 招生渠道类型
      SchoolsourceOption: [],
      ActivityOption: [],
      ChannelOption: [],
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      SchoolCourseOption: [], //意向课程
      repeatList: [], //重复记录列表
      isrepeat: false,
      isRoot: false,
      //用户基本信息
      UserInformation: [],
      FriendRelation: [], //用户绑定关系
      BindingInfor: [],
      FriendName: [], //用户绑定人员名称
      from_client_id: "",
      layoutChiefPerson: [], //分配负责人
      ClientId: "", //暂存分配Id
      moreClientId: [], //暂存分配Id
      isdistrib: false, //是否点击分配
      isTrack: false, //是否点击跟进
      Personinfor: "", //分配人
      Distribinfor: "", //被分配人
      leaningVisible: false,
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      moreVisible: false,
      current: 0,
      input: "",
      input10: "",
      value11: "",
      select: "",
      visitedJG: false,
      createJG: false,
      visitingJG: false,
      sliderWidth: "700px",
      settingchecked: "",
      activeName: "first",
      radio: "1",
      listshow1: false,
      listshow2: false,
      buttonHide: false,
      // checkList: ["1", "柜询"],
      Userlistcreate: {
        containClass: "slider-admissionCue",
        sliderTitle: this.$t("Admissioncue.ac"),
      },
      Userlistedit: {
        containClass: "slider-admissionCue",
        sliderTitle: this.$t("Admissioncue.bsw"),
      },
      isEdit: true,
      filtersOption: [this.$t("Admissioncue.by"), this.$t("Admissioncue.bz")],
      //数据筛选
      selectForm: {
        client_isnewtip: "", //是否名单更新 1 已读   0未读
        source: "",
        status: "",
        keyword: "",
        activity: "",
        channel: "",
        lapsed: "",
        range_time: "", //创建时间
        client_status: "", //名单状态 0 待分配 1未跟踪 2已邀约 3已试听 4已跟踪 -1 无意向
        client_track_status: "", //跟踪状态 0-待分配 ,1-待跟踪 2-跟踪中,3已转正 -1无意向
        family_mobile: "",
      },
      //多条线索信息
      MultipleClues: [],
      isMultiple: false, //是否批量分配
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      loading: false,
      //分配负责人
      layoutFrom: {
        marketer: "",
        fu_marketer: [],
      },
      // 分配用户信息暂存
      layoutInformation: [],
      allotTips: "", //分配返回值
      allot_num: "", //分配返回值
      // 侧边栏 跟进基础信息
      clientLevelNum: [], //意向星级
      followFormid: "",
      CommodeData: [], //获取沟通类型
      FamilyRelation: [], //获取家庭亲属关系
      TraceNoteData: [], //沟通模板
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        mutiSelectDisable: true, //是否disable复选框
        errortip: "",
        isShowPersonInfo: true, //是否显示个人资料保护法标识
      },
      columns: [],
      operates: {
        width: 200,
        label: this.$t("Admissioncue.ca"),
        align: "center",
        fixed: "right",
        dropDown: true, //下拉菜单形式
        // list: [
        //   {
        //     id: "1",
        //     label: "分配",
        //     type: "text",
        //     show: true,
        //     plain: true,
        //     disabled: false,
        //     noPermission: true,
        //     method: (index, row) => {
        //       this.assignClick(row);
        //     }
        //   },
        //   {
        //     id: "2",
        //     label: "我要跟进",
        //     type: "text",
        //     show: true,
        //     plain: true,
        //     floowMe: true,
        //     disabled: false,
        //     method: (index, row) => {
        //       this.handleClick(row);
        //     }
        //   },
        //   {
        //     id: "3",
        //     label: "转校",
        //     type: "text",
        //     show: true,
        //     plain: true,
        //     floowMe: true,
        //     disabled: false,
        //     method: (index, row) => {
        //       this.ClientOneId = row.client_id;
        //       this.handleCrossSchool(row);
        //     }
        //   }
        // ]
        list: [
          {
            id: "1",
            label: this.$t("Admissioncue.bd"),
            show: true,
            name: "distribution",
            noPermission: true,
          },
          {
            id: "2",
            label: this.$t("Admissioncue.cb"),
            name: "fllow",
            show: true,
            floowMe: true,
          },
          {
            id: "3",
            label: this.$t("Admissioncue.cc"),
            show: true,
            name: "changeSchool",
            changeSchool: true,
          },
          // {
          //   id: "4",
          //   label: "删除重复",
          //   show: true,
          //   delRepeat: true,
          //   name:"delRepeate",
          // }
        ],
      }, // 列操作按钮
      // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 跟踪记录
      recordData: [],
      currentrecordData: [], //最近跟踪记录
      //柜询记录
      recordcolumnWidth: ["150", "150", "250", "auto"],
      tryRecordlist: [],
      recordlistColumn: [],
      recordoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
      },
      recordOperates: {
        width: 200,
        label: this.$t("Admissioncue.ca"),
        align: "center",
        fixed: "right",
        list: [],
      },
      //试听课程表格开始
      //试听课程表格结束
      classResult: [],
      //selcet 搜索
      value8: "",
      //selcet 搜索
      value9: "",
      notreadnum: 0, //未读提醒人数
      isShowListTips: true, //是否显示名单更新
    };
  },
  components: {
    PageNav,
    TableList,
    tipsTable,
    userCreate,
    userSeeing,
    auditClass,
    SliderBox,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.getgetClientData(this.pagenum, "");
    (() => {})(this.$store.state.MARKETER_ID);
    this.isStatues();
    this.getSourceData();
    this.getMarketer(); // 获取招生的负责人
    this.getIntentCourseData(); // 获取意向课程
    this.getCommodeData(); //获取沟通类型
    this.getTraceNoteData(); //获取沟通模板
    // this.getClientNameData();//绑定学员->获取人员名称
    this.getFamilyRelationData(); // 获取家庭亲属关系
    // this.getActivityData(); //获取活动名称
    this.getChannelData(); //获取招生渠道明细
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(390); //设置表格高度
  },
  computed: {
    filteredItems: function() {
      return this.recordData.slice(0, 2);
    },
    company_isassist() {
      return this.$store.state.companyIsassist;
    },
  },
  methods: {
    updateList() {
      this.getgetClientData(this.pagenum, "");
    },
    // 判断是否是其他页面跳转
    isStatues() {
      var url = window.location.search.substr(1);
      if ((url = "statues=1")) {
        // this.dialogVisible = false;
        // this.isRoot = true;
        // this.activeName = "fourth";
        // this.showSliderBoxSee = true;
      }
    },
    // 招生有效名单表格数据
    getgetClientData(page, classfiy) {
      //  (() => {})(this.selectForm.source,this.selectForm.status)
      var $source = this.selectForm.source;
      if ($source == this.$t("Admissioncue.am")) {
        $source = "";
      }
      storeAdmissionCue
        .getClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          is_today: classfiy,
          client_source: $source,
          postbe_crmuserlevel: this.postbe_crmlevel,
          client_tracestatus: this.selectForm.status,
          keyword: this.selectForm.keyword,
          activity_id: this.selectForm.activity,
          channel_id: this.selectForm.channel,
          parenter_mobile: this.selectForm.family_mobile,
          lapsed: this.selectForm.lapsed,
          create_starttime: this.selectForm.range_time
            ? this.selectForm.range_time[0]
            : "",
          create_endtime: this.selectForm.range_time
            ? this.selectForm.range_time[1]
            : "",
          client_status: this.selectForm.client_status,
          client_track_status: this.selectForm.client_track_status,
          client_isnewtip: this.selectForm.client_isnewtip, //是否名单更新
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const allnum = body.allnum;
          const data = body;
          this.tableData = data.list;
          this.dataNumber = parseInt(allnum);
          this.ActivityOption = data.activity_list;
          // this.data=data.field;
          var Columns = data.field;
          this.allColumns = data.field;
          this.$Tool.setStorage("alladmColumns", this.allColumns);
          this.showColumn = JSON.parse(localStorage.getItem("showadmColumns"));
          var fieldColumns = data.field;
          if (JSON.parse(localStorage.getItem("showadmColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          console.warn(this.columns);
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }
          this.notreadnum = res.data.data.notreadnum;
          (() => {})(arr);
        });
    },
    // 获取转校学校列表
    getAllSchoolApi() {
      storeAdmissionCue
        .getAllSchoolApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.schoolGoalList = res.data.data.list;
        });
    },
    // 获取转校原因
    getTransferCnameApi() {
      storeAdmissionCue
        .getTransferCnameApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.reasonList = res.data.data.list;
        });
    },
    transferSchoolAction() {
      storeAdmissionCue
        .transferSchoolAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.ClientOneId,
          re_school_id: this.crossSchoolFrom.school,
          note: this.crossSchoolFrom.reason,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
            this.crossSchoolVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //获取招生渠道类型
    getSourceData() {
      storeAdmissionCue
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          // this.SchoolsourceOption.unshift({
          //   frommedia_id: "",
          //   frommedia_name: "不限"
          // });
        });
    },
    //获取活动名称
    getActivityData() {
      storeAdmissionCue
        .getActivity({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.ActivityOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      storeAdmissionCue
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.ChannelOption = res.data.data.list;
          // this.ChannelOption.unshift({
          //   channel_id: "",
          //   channel_name: "不限"
          // });
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeAdmissionCue
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift(
          //   {
          //     marketer_id: "", marketer_name: "不限"
          //   })
        });
    },
    // 获取副负责人
    getfiterChief() {
      storeAdmissionCue
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          main_marketer_id: this.layoutFrom.marketer,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.fu_chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift(
          //   {
          //     marketer_id: "", marketer_name: "不限"
          //   })
        });
    },
    //获取意向课程
    getIntentCourseData() {
      // SchoolClassOption
      storeAdmissionCue
        .getIntentCourse({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
          //重置筛选
          // this.SchoolCourseOption.unshift(
          //   {
          //     coursecat_id: "", coursecat_cnname
          //   }
          // );
        });
    },
    // 获取家庭亲属关系
    getFamilyRelationData() {
      storeAdmissionCue
        .getFamilyRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.FamilyRelation = res.data.data.list;
        });
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      storeAdmissionCue
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.UserInformation = res.data.data.list;
        });
    },
    // 获取单个客户的跟踪记录
    getclientOneTrackData(id) {
      storeAdmissionCue
        .getclientOneTrack({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          var arr = [];
          res.data.data.list.forEach((item) => {
            var str;
            if (item.track_followmode == "0") {
              str = this.$t("Admissioncue.cd");
            }
            if (item.track_followmode == "1") {
              str = this.$t("Admissioncue.ce");
            }
            if (item.track_followmode == "2") {
              str = this.$t("Admissioncue.cf");
            }
            if (item.track_followmode == "3") {
              str = this.$t("Admissioncue.cg");
            }
            if (item.track_followmode == "-1") {
              str = this.$t("Admissioncue.ch");
            }
            arr.push(
              Object.assign({}, item, {
                track_followcont: str,
              })
            );
          });
          this.recordData = arr;
          this.currentrecordData = arr.slice(0, 2);
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeAdmissionCue
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 获取单个客户的绑定学员信息
    getBindingClientData(id) {
      // BindingInfor
      storeAdmissionCue
        .getBindingClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.BindingInfor = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      (() => {})(this.BindstudentFrom.name);
      storeAdmissionCue
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    // 获取单个客户的柜询记录-
    getclientOneInviteData(id) {
      storeAdmissionCue
        .getclientOneInvite({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryRecordlist = res.data.data.list;
          var Columns = res.data.data.field;
          this.recordlistColumn = this.$Common.handleTable(
            Columns,
            this.ClasscolumnWidth,
            false,
            0
          );
        });
    },
    //获取单个客户的试听记录-
    getclientOneAuditionData(id) {
      storeAdmissionCue
        .getclientOneAudition({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryClasslist = res.data.data.list;
          var Columns = res.data.data.field;
          this.ClasslistColumn = this.$Common.handleTable(
            Columns,
            this.recordcolumnWidth,
            false,
            0
          );
        });
    },
    // 获取沟通类型
    getCommodeData() {
      storeAdmissionCue
        .getCommode({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.CommodeData = res.data.data.list;
          (() => {})(res.data.data.list);
        });
    },
    // 获取沟通模板
    getTraceNoteData() {
      storeAdmissionCue
        .getTraceNote({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.TraceNoteData = res.data.data.list;
          (() => {})(res.data.data.list);
        });
    },
    // 点击功能菜单***8获取每条数据
    dropdownClick(row) {
      (() => {})(row, 1212);
      this.layoutInformation = row;
      this.ClientId = row.client_id;
      this.ClientOneId = row.client_id;
      this.followFormid = row.client_id; //跟进
      this.from_client_id = row.client_id;
      this.customerId = row.client_id; //存储客户ID
    },
    // 点击功能菜单
    handleCommand(command) {
      (() => {})(command);
      if (command == "distribution") {
        // 分配
        (this.layoutFrom = {
          marketer: "",
          fu_marketer: [],
        }), //初始化
          (this.layoutVisible = true);
        this.isMultiple = false;
      } else if (command == "fllow") {
        // 我要跟进
        this.Fllowintention(this.ClientId); //转为我的意向客户
        this.getclientOneData(this.ClientId);
        this.dialogVisible = true;
        this.isRoot = true;
        this.iscanEdit = false;
        this.activeName = "fourth";
        this.isdistrib = true; //是否点击分配
        this.isTrack = true; //是否点击我要跟进
      } else if (command == "changeSchool") {
        // 转校
        this.handleCrossSchool();
      } else if (command == "delRepeate") {
        // 删除重复
        this.delRepeat = true;
      }
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      if (this.current == 0) {
        this.getgetClientData(this.pagenum, "");
      } else {
        this.getgetClientData(this.pagenum, "1");
      }
    },
    // 转校原因
    changReason() {
      let reson_code = this.crossSchoolFrom.reson_code,
        reason = "";
      this.reasonList.forEach((item) => {
        if (item.transfer_code == reson_code) {
          reason = item.transfer_name;
        }
      });
      this.crossSchoolFrom.reason = reason;
    },
    // 转校
    handleCrossSchool() {
      this.getAllSchoolApi();
      this.getTransferCnameApi();
      // 数据初始化
      this.crossSchoolFrom = {
        school: "",
        reson_code: "",
        reason: "",
      };
      this.crossSchoolVisible = true;
    },
    // Crm->删除重复名单
    delRepeatAction() {
      this.$http
        .delRepeatAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.ClientOneId,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
            this.delRepeat = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 转校提交
    onCrossSchoolSubmit() {
      this.transferSchoolAction();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      if (this.current == 0) {
        this.getgetClientData(this.pagenum, "");
      } else {
        this.getgetClientData(this.pagenum, "1");
      }
    },
    // 招生有效名单->批量无意向
    handleClickloss() {
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeAdmissionCue
        .gettoLossClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 招生有效名单->流转为我的意向客户
    handleClickintention() {
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeAdmissionCue
        .gettoMyClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 跟进转为我的意向客户
    Fllowintention(id) {
      storeAdmissionCue
        .addallotClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
          main_marketer_id: this.marketer_id,
          crm_from: "1", ////我要跟进标识
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.layoutVisible = false;
            this.isdistrib = true;
            this.Personinfor = res.data.data.list.client_cnname;
            this.Distribinfor = res.data.data.list.marketer_name;
            this.allotTips = res.data.data.tip;
            this.allot_num = res.data.data.allot_num;
            this.dialogVisible = true;
            this.getgetClientData(this.pagenum, "");
          } else {
            this.allotTips = res.data.data.tip;
            this.allot_num = res.data.data.allot_num;
          }
        });
    },
    // 招生有效名单批量分配
    handleClickassign() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      this.ClientId = arrMultiple;
      this.isMultiple = true;
      this.layoutVisible = true;
    },
    // 新增招生有效名单
    addClientData(data) {
      storeAdmissionCue.addClient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.current = 0;
          this.getgetClientData(this.pagenum, "");
          this.showSliderCreateBox = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 编辑招生有效名单
    editClientData(data) {
      storeAdmissionCue.editClient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.showSliderBox = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 新增时-检测重名
    checkIntentionClientData(val) {
      (() => {})(this.customerId, 12213);
      var id;
      if (this.isEdit) {
        id = this.customerId;
      } else {
        id = "";
      }
      storeAdmissionCue
        .checkIntentionClient({
          token: this.token,
          marketer_id: this.marketer_id,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: val.client_cnname,
          client_mobile: val.client_mobile,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.isrepeat = false;
          } else {
            if (res.data.data.list != undefined) {
              this.isrepeat = true;
              this.repeatList = res.data.data.list;
            }
          }
        });
    },
    //编辑时删除家庭信息
    deleteFamily(v) {
      if (v.family_id) {
        storeAdmissionCue
          .delFamilyRelation({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            family_id: v.family_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //编辑时删除课程信息
    deleteCourse(v) {
      if (v.intention_id) {
        storeAdmissionCue
          .delIntentionSource({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            intention_id: v.intention_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //分配
    // 招生目标线索->为客户分配负责人
    addallotClient(id, more) {
      var clientId = [];
      if (more == 1) {
        clientId.push(id);
      } else {
        clientId = id;
      }
      storeAdmissionCue
        .addallotClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: clientId,
          main_marketer_id: this.layoutFrom.marketer,
          fu_marketer_id: this.layoutFrom.fu_marketer,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.layoutVisible = false;
            this.isdistrib = false;
            this.Personinfor = res.data.data.list.client_cnname;
            this.Distribinfor = res.data.data.list.marketer_name;
            this.allotTips = res.data.data.tip;
            this.dialogVisible = true;
            this.getgetClientData(this.pagenum, "");
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //分配提交
    onlayoutSubmit() {
      // (() => {})(this.layoutFrom);
      (() => {})(this.isMultiple);
      if (this.isMultiple) {
        this.addallotClient(this.ClientId, 0); //单个分配
      } else {
        this.addallotClient(this.ClientId, 1); //批量分配
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeAdmissionCue
        .bindingClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      // this.getclientOneData(this.customerId);
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      (() => {})(v);
      storeAdmissionCue.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("alladmColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showadmColumns", this.showColumns);
      this.settingVisible = false;
      this.getgetClientData(this.pagenum);
      (() => {})(allnum);
    },
    // 编辑列
    Changeoprate() {
      (() => {})("列变化");
    },
    // 点击新增招生有效名单
    ClickAddAdmission() {
      this.isrepeat = false;
      this.showSliderCreateBox = true;
    },
    // 导入招生名单
    importAdmission() {
      this.$router.push({ path: "/Admissioncue/importAdmission" });
    },
    hideSliderBox() {
      this.showSliderBox = false;
      this.showSliderCreateBox = false;
    },
    sourceFilter() {
      (() => {})(this.checkList);
    },
    hideSliderCreateBox() {
      this.showSliderCreateBox = false;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    //新增招生有效名单提交
    onSubmit(value) {
      (() => {})(value);
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        this.addClientData(value);
      } else {
        this.$message({
          message: this.$t("Admissioncue.ck"),
          type: "error",
        });
      }
    },
    //编辑招生有效名单提交
    oneditSubmit(value) {
      (() => {})(value);
      // value["marketer_id"] = this.marketer_id;
      // value["token"] = this.token;
      // value["school_id"] = this.school_id;
      // value["company_id"] = this.company_id;
      let newVal = value;
      newVal["marketer_id"] = this.marketer_id;
      newVal["token"] = this.token;
      newVal["school_id"] = this.school_id;
      newVal["company_id"] = this.company_id;
      this.$delete(newVal, "client_tag");
      this.$delete(newVal, "client_tags");
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        // this.editClientData(value);
        this.editClientData(newVal);
      } else {
        this.$message({
          message: this.$t("Admissioncue.ck"),
          type: "error",
        });
      }
    },
    // 我要跟踪
    wantToTrack(v) {
      this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.followFormid = v.client_id; //跟进
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.showSliderCreateBox=false;
      this.showSliderBoxSee = true;
      this.isRoot = true;
      this.iscanEdit = false;
      this.activeName = "fourth";
      this.isdistrib = true; //是否点击分配
      this.isTrack = true; //是否点击我要跟进
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    //我要跟进
    handleClick(v) {
      this.Fllowintention(v.client_id); //转为我的意向客户
      this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.followFormid = v.client_id; //跟进
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.dialogVisible = true;
      this.isRoot = true;
      this.iscanEdit = false;
      this.activeName = "fourth";
      this.isdistrib = true; //是否点击分配
      this.isTrack = true; //是否点击我要跟进
      // this.showSliderBoxSee = true;
      (() => {})(v);
    },
    //立即跟进
    handclickNow(v) {
      console.warn(v);
      this.showSliderBoxSee = true;
      this.dialogVisible = false;
      this.isDisabled = true;
      // this.$router.push({
      //   path:`/Customersmanage/custoMersmanage?client_id=${v.client_id}`
      //   });
      // // 调用方
      // util.$emit('test',v);
    },
    handleClose(done) {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      if (this.current == 0) {
        this.getgetClientData(this.pagenum, "");
      } else {
        this.getgetClientData(this.pagenum, "1");
      }
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      if (this.current == 0) {
        this.getgetClientData(this.pagenum, "");
      } else {
        this.getgetClientData(this.pagenum, "1");
      }
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      this.isFromGmc = val.some(
        (v) => v.isgmcIndschoolenter == 1 && v.isgmcschoolenter != 1
      );
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
    },
    //更多下拉
    handmoreVisible() {
      if (this.moreVisible == false) {
        this.moreVisible = true;
      } else {
        this.moreVisible = false;
      }
    },
    //分配弹窗
    assignClick(v) {
      this.layoutInformation = v;
      (this.layoutFrom = {
        marketer: "",
        fu_marketer: [],
      }), //初始化
        (this.layoutVisible = true);
      this.isMultiple = false;
      this.ClientId = v.client_id;
      (() => {})(v);
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean(done) {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then((_) => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    //点击查看
    handleColumnChange(k, v) {
      console.warn(k, v);
      this.newclientTags = v.client_tag;
      this.isRoot = false;
      this.activeName = "first";
      this.isTrack = false;
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
      this.isDisabled = false;
    },
    //筛选
    handleFilter() {
      this.filterActive = true;
    },
    // tab切换
    addClass: function(index) {
      this.current = index;
      // 筛选数据清空
      this.selectForm = {
        source: "",
        status: "",
        keyword: "",
        activity: "",
        channel: "",
        family_mobile: "",
      };
      this.currentPage = 1;
      if (index == 1) {
        // this.$router.push({path: '/Admissioncue/admissionCue', query: {is_today: "1"}})
        this.getgetClientData(this.pagenum, "1");
      } else {
        // this.$router.push({path: '/Admissioncue/admissionCue', query: {is_today: ""}})
        this.getgetClientData(this.pagenum, "");
      }
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let $source = this.selectForm.source;
      if ($source == this.$t("Admissioncue.am")) {
        $source = "";
      }
      let create_starttime = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      let create_endtime = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      let is_today = this.current == 1 ? "1" : "";
      params_str = `&is_today=${is_today}&client_source=${$source}&client_tracestatus=${this.selectForm.status}&keyword=${this.selectForm.keyword}&activity_id=${this.selectForm.activity}&channel_id=${this.selectForm.channel}&parenter_mobile=${this.selectForm.family_mobile}&lapsed=${this.selectForm.lapsed}&client_status=${this.selectForm.client_status}&client_track_status=${this.selectForm.client_track_status}&create_starttime=${create_starttime}&create_endtime=${create_endtime}`;
      let url = storeAdmissionCue.getClient1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("admissionCue.less");

.admissionCue {
  height: 100vh;
  font-size: 20px;
}
</style>
